import { throwCmtsCanonicalError } from "./cmtsApiErrors.js";

export type CmtsPathParameters = Record<string, string | number | boolean | null | undefined>;

export function resolveCmtsPathTemplate(template: string, params: CmtsPathParameters = {}): string {
  return template.replace(/\{([^}]+)\}/g, (_match, rawName: string) => {
    const name = rawName.trim();
    const value = params[name];
    if (value === undefined || value === null || value === "") {
      throwCmtsCanonicalError({ code: "CMTS_ERR_MISSING_ROUTE_PARAM", field: name, message: `CMTS path parameter '${name}' is required for '${template}'.`, details: { template, parameter: name } });
    }
    return encodeURIComponent(String(value));
  });
}

export function getMissingCmtsPathParameters(template: string, params: CmtsPathParameters = {}): readonly string[] {
  const required = [...template.matchAll(/\{([^}]+)\}/g)].map((match) => String(match[1]).trim());
  return required.filter((name) => params[name] === undefined || params[name] === null || params[name] === "");
}
